import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CloudIcon from '@mui/icons-material/Cloud';
import { onSnapshot, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams } from 'react-router-dom';

function Widget({ type }) {
  const [amount, setAmount] = useState(null);
  const { userId } = useParams();
  let data;

  switch (type) {
    case 'space':
      data = {
        title: 'UPLOADED PHOTOS LEFT',
        link: 'See space details',
        query: 'users',
        icon: <CloudIcon className="icon" />,
      };
      break;

    default:
      break;
  }

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'users', userId), (doc) => {
      setAmount(doc.data().space.toFixed(2));
    });

    return () => {
      unsub();
    };
  }, [userId]);

  return (
    <WidgetStyled>
      <div className="left">
        <span className="title">{data.title}</span>
        {amount < 1000 ? (
          <span className="counter">{amount} MB</span>
        ) : (
          <span className="counter">{amount / 1000} GB</span>
        )}
        <span className="link">Space left</span>
      </div>
      <div className="right">
        <div className="percentage positive">{data.diff}</div>
        {data.icon}
      </div>
    </WidgetStyled>
  );
}

const WidgetStyled = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  padding: 10px;
  -webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 2px 4px 10px 1px rgba(201, 201, 201, 0.4);
  height: 120px;

  .left,
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 14px;
      color: var(--accent-blue);
    }
    .counter {
      font-size: 28px;
      font-weight: 300;
      color: #333;
    }
    .link {
      width: max-content;
      font-size: 12px;
      border-bottom: 1px solid rgb(231, 228, 228);
      color: #333;
    }

    .icon {
      font-size: 28px;
      padding: 5px;
      background-color: var(--accent-blue);
      border-radius: 5px;
      align-self: flex-end;
      color: #fff;
    }
  }
`;

export default Widget;
